import { render, staticRenderFns } from "./SPRObjectCheckboxList.vue?vue&type=template&id=5fb389b1"
import script from "./SPRObjectCheckboxList.vue?vue&type=script&lang=ts"
export * from "./SPRObjectCheckboxList.vue?vue&type=script&lang=ts"
import style0 from "./SPRObjectCheckboxList.vue?vue&type=style&index=0&id=5fb389b1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports